module.exports = __webpack_public_path__ + "static/img/Crait_Resource_14.7547061.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180419/Crait_Resource_14.jpeg
// module id = 258
// module chunks = 1